import { render, staticRenderFns } from "./flashSaleInfo.vue?vue&type=template&id=ffbc5a4e"
import script from "./flashSaleInfo.vue?vue&type=script&lang=js"
export * from "./flashSaleInfo.vue?vue&type=script&lang=js"
import style0 from "./flashSaleInfo.vue?vue&type=style&index=0&id=ffbc5a4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports